import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  MemoryRouter,
  useLocation,
  useNavigationType,
  useRoutes,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from 'posthog-js/react'
import './index.css';
import App, { Providers } from './App';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './hooks/useToast';
import './i18n'
import { AccountModal } from './components/topbar/components/AccountModalMenus';
import { ModalProvider } from './hooks/useModal';

Sentry.init({
  dsn: "https://1cf2d83abdf0fa694b37d37792093d24@o4506075695284224.ingest.us.sentry.io/4507936481148928",
  environment: process.env.REACT_APP_ENV,
  release: process.env.REACT_APP_COMMIT_ID,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      networkCaptureBodies: true,
      networkDetailAllowUrls: [/^https:\/\/(.*\.)?zaviago\.com/],
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/(.*\.)?zaviago\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export const useSentryRoutes = Sentry.wrapUseRoutes(useRoutes);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        person_profiles: 'identified_only',
      }}
    >
      <ModalProvider>
        <ToastProvider>
          <Providers>
            <BrowserRouter>
              <App />
            </BrowserRouter>
            <MemoryRouter initialEntries={["/account"]}>
              <AccountModal showLeftButton={true}/>
            </MemoryRouter>
          </Providers>
        </ToastProvider>
      </ModalProvider>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
